import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import PropTypes from "prop-types";
import styled from "styled-components";
import { LoadingSpinnerButton } from "./PathwayButtons";
import { FlexibleButtonModalFooter } from "../StyledComponents/PathwayModal";
import { ErrorMessage, WarningMessage } from "./Alerts/PathwayAlertMessages";

export const ModalS = (props) => {
    const handleSubmit = (e) => {
        props.handleSubmit(e);
        if (props.submitAndToggle) {
            props.toggleModal();
        }
    };

    const primaryButton = !props.hidePrimaryButton && (
        <LoadingSpinnerButton
            loading={props.isLoading}
            onClick={handleSubmit}
            disabled={props.disabled}
            buttonCyData={props.buttonCyData || props.dataCy + "-submit-button"}
        >
            {props.primaryButtonText}
        </LoadingSpinnerButton>
    );

    const cancelButton = (
        <Button
            color="secondary"
            onClick={props.toggleModal}
            data-cy={props.dataCy ? props.dataCy + "-cancel-button" : undefined}
        >
            {props.secondaryButtonText || "Abbrechen"}
        </Button>
    );

    return (
        <Modal isOpen={props.isOpen} size={props.size} data-cy={props.dataCy + "-modal"}>
            <ModalHeader toggle={props.toggleModal}>{props.title}</ModalHeader>
            <ModalBody data-cy={props.dataCy + "-modal-body"}>
                {props.children}
                <WarningMessage useTopMargin={true} useBottomMargin={false}>
                    {props.warningMessage}
                </WarningMessage>
                <ErrorMessage useTopMargin={true} useBottomMargin={false}>
                    {props.errorMessage}
                </ErrorMessage>
            </ModalBody>
            {props.leftFooterContent ? (
                <SpaceBetweenModalFooter>
                    <FooterSide>{props.leftFooterContent}</FooterSide>
                    <FooterSide>
                        {primaryButton}
                        {cancelButton}
                    </FooterSide>
                </SpaceBetweenModalFooter>
            ) : (
                <FlexibleButtonModalFooter>
                    {primaryButton}
                    {cancelButton}
                </FlexibleButtonModalFooter>
            )}
        </Modal>
    );
};

const SpaceBetweenModalFooter = styled(ModalFooter)`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const FooterSide = styled.div`
    display: flex;
    align-items: center;
    gap: var(--gap-m, 12px);
`;

ModalS.propTypes = {
    title: PropTypes.string.isRequired,
    primaryButtonText: PropTypes.string.isRequired,
    isOpen: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool.isRequired,
    disabled: PropTypes.bool,
    children: PropTypes.node.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    toggleModal: PropTypes.func.isRequired,
    warningMessage: PropTypes.string,
    errorMessage: PropTypes.string,
    hidePrimaryButton: PropTypes.bool,
    size: PropTypes.any,
    secondaryButtonText: PropTypes.string,
    buttonCyData: PropTypes.string,
    dataCy: PropTypes.string,
    leftFooterContent: PropTypes.node,
};
